import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'sl10',
  templateUrl: './sl10.component.html',
  styleUrls: ['./sl10.component.scss']
})
export class SL10Component {
  @Input() package: any;
  company = environment.company;
}
